export default __webpack_public_path__ + "static/media/Screenshot 2023-09-13 at 10.11.49 AM.3616bcab.png";